var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCarPlayAndroidAudio32 = function SvgCarPlayAndroidAudio32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.521 3H7.48C4.453 3 2 5.443 2 8.456v15.088C2 26.557 4.453 29 7.479 29H24.52c3.027 0 5.48-2.443 5.48-5.456V8.456C30 5.443 27.547 3 24.521 3Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 14.207v3.586a.24.24 0 0 0 .024.102.197.197 0 0 0 .063.076.158.158 0 0 0 .086.029c.03 0 .06-.008.088-.025l2.65-1.797a.196.196 0 0 0 .065-.077.24.24 0 0 0 0-.21.196.196 0 0 0-.065-.078l-2.65-1.788a.156.156 0 0 0-.088-.025.14.14 0 0 0-.086.03.197.197 0 0 0-.063.075.24.24 0 0 0-.024.102Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 22a6 6 0 1 0 0-12 6 6 0 0 0 0 12ZM2.02 10c1.137.329 2.147 1.1 2.87 2.19.721 1.09 1.112 2.435 1.11 3.82-.002 1.384-.398 2.727-1.123 3.813C4.15 20.91 3.138 21.677 2 22m28 0c-1.138-.323-2.15-1.09-2.876-2.175-.726-1.087-1.121-2.43-1.124-3.814-.003-1.385.388-2.73 1.11-3.82.72-1.09 1.73-1.862 2.867-2.191",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
};
export default SvgCarPlayAndroidAudio32;